// extracted by mini-css-extract-plugin
export default {"btn":"back-button_btn__f8xOL"};